import template from './item.edit.html';
import controller from './item.edit.controller';
import './item.edit.scss';

let itemeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default itemeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/item/edit/item.edit.component.js